import { render, staticRenderFns } from "./GoodRead.vue?vue&type=template&id=0a40bc7a&scoped=true&"
import script from "./GoodRead.vue?vue&type=script&lang=js&"
export * from "./GoodRead.vue?vue&type=script&lang=js&"
import style0 from "./GoodRead.vue?vue&type=style&index=0&id=0a40bc7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40bc7a",
  null
  
)

export default component.exports